import styled from 'styled-components'

import { WalletAssetItemPrice } from '../../../wallet-asset/common/wallet-asset-item/wallet-asset-item-price'

import type { BigNumber } from 'bignumber.js'

type Props = {
  ticker: string
  priceUsd: BigNumber
  endSlot?: React.ReactNode
}

export const WalletAssetsPriceCell: React.FC<Props> = ({
  ticker,
  priceUsd,
  endSlot,
}) => {
  return (
    <Root>
      <WalletAssetItemPrice ticker={ticker} priceUsd={priceUsd} />
      {endSlot}
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
`
